import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { CellContext } from '@tanstack/react-table';

export interface ChargePointListLocationCityCellProps
  extends CellContext<
    GatewayChargePointModel,
    GatewayChargePointModel['location']
  > {}

export const ChargePointListLocationCityCell = (
  props: ChargePointListLocationCityCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()?.city ?? '-'}</Text>;
};
